import React, { useState, useEffect, useRef } from 'react';
import './Profile.css';
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Profile = () => {

    const bearerToken = localStorage.getItem('bearerToken');
    if (!bearerToken) window.location.href = '/login';

    const [Newpassword, setNewpassword] = useState("");
    const [Newconfirm, SetNewconfirm] = useState("");
    const [showNewconfirm, setShowNewconfirm] = useState(false);
    const [showNewpassword, setShowNewpassword] = useState(false);
    const [showOldpassword, setShowOldpassword] = useState(false);
    const [oldPassword, setOldPassword] = useState("");
    const [isPersonalModalOpen, setIsPersonalModalOpen] = useState(false);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [user, setUser] = useState(null);
    const [activeTab, setActiveTab] = useState('editProfile');
    const [fullName, setFullName] = useState('');
    const [dob, setDob] = useState('');
    const [frequentFlyerNumber, setFrequentFlyerNumber] = useState('');
    const [mobileCode, setMobileCode] = useState('');
    const [mobNo, setMobNo] = useState('');
    const loginDetailsRef = useRef(null);
    const [countryCode, setCountryCode] = useState([]);
    const setFullNamea = (value) => {
        setUser((prevUser) => ({
            ...prevUser,
            employeeName: value,
        }));
    };
    const setFrequentFlyerNumbera = (value) => {
        setUser((prevUser) => ({
            ...prevUser,
            frequentFlyerNo: value,
        }));
    };
    const setDoba = (value) => {
        setUser((prevUser) => ({
            ...prevUser,
            dob: value,
        }));
    };
    const getcountryCode = async (query) => {
        try {
            const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/getCountryCodeList`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + bearerToken,
                },
            });
            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('bearerToken');
                    localStorage.removeItem('policies');
                    sessionStorage.removeItem('policies');
                    localStorage.removeItem('user');
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            const result = await response.json();
            setCountryCode(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (countryCode.length === 0) {
            getcountryCode();
        }
    }, [countryCode]);
    const openPersonalModal = () => setIsPersonalModalOpen(true);
    const closePersonalModal = () => {setIsPersonalModalOpen(false); getUser();}

    const openLoginModal = () => setIsLoginModalOpen(true);
    const closeLoginModal = () => setIsLoginModalOpen(false);
    const handleCountryChange = (e) => {
        const selectedCode = e.target.value;
        setMobileCode(selectedCode);
        setUser((prevState) => ({ ...prevState, countryCode: selectedCode }));
    };
    const getUser = async () => {
        try {
            const response = await fetch(`https://cbtflightmidapi.blueberry-travel.com/api/Employee/getUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${bearerToken}`,
                },
            });
            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('bearerToken');
                    localStorage.removeItem('policies');
                    sessionStorage.removeItem('policies');
                    localStorage.removeItem('user');
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            };
            const result = await response.json();
            setUser(result.data);
            console.log(result.data);
            localStorage.setItem('user', JSON.stringify(result.data));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const setUserDetail = async () => {
        try {
            var data = {
                id: user.employeeId,
                email: user.employeeEmail,
                fullName: user.employeeName,
                mobileNo: user.mobileNo,
                dob: user.dob,
                countryCode: user.countryCode,
                frequentFlyerNo: user.frequentFlyerNo,
                Password: '',
                isActive: user.isActive,
                isAdmin: user.isAdmin,
                managerId: user.managerId,
                status: true
            };
            const response1 = await fetch(`https://cbtflightmidapi.blueberry-travel.com/api/Employee/createUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${bearerToken}`,
                },
                body: JSON.stringify(data),
            });
            if (!response1.ok) {
                if (response1.status === 401) {
                    localStorage.removeItem('bearerToken');
                    localStorage.removeItem('policies');
                    sessionStorage.removeItem('policies');
                    localStorage.removeItem('user');
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
                throw new Error(`Error ${response1.status}: ${response1.statusText}`);
            }
            const result = await response1.json();
            if (result.status === "success") {
                closePersonalModal();
                alert("Updated Successfully.");
                return;
            }
            else {
                closePersonalModal();
                alert(result.status);
            }
            closePersonalModal();
            console.log(result);
            getUser();
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const setPassword = async () => {
        try {
            if (oldPassword === "") {
                alert("Enter old Password");
                return;
            }
            if (Newpassword === "") {
                alert("Enter new Password.");
                return;
            }
            if (Newconfirm === "") {
                alert("Enter new confirm Password.");
                return;
            }
            if (oldPassword === Newpassword) {
                alert("Old Password and New Password Can't be Same.");
                return;
            }
            if (Newconfirm !== Newpassword) {
                alert("Please Enter New password and confirm Password same.");
                return;
            }
            const response = await fetch(`https://cbtflightmidapi.blueberry-travel.com/api/Employee/changePassword?emailId=` + user.employeeEmail + `&oldPassword=` + oldPassword + `&newPassword=` + Newpassword + ``, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${bearerToken}`,
                }
            });
            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('bearerToken');
                    localStorage.removeItem('policies');
                    sessionStorage.removeItem('policies');
                    localStorage.removeItem('user');
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            const result = await response.json();
            if (result.status === "success") {
                closeLoginModal();
                alert("Changed Successfully.");
                return;
            }
            else {
                closeLoginModal();
                alert(result.message);
            }
            closeLoginModal();
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        if (tabName === 'changePassword') {
            loginDetailsRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        if (!user) {
            getUser();
        }
    }, [user]);
    
    const modalRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                closePersonalModal(); // Close modal when clicking outside
            }
        };

        if (isPersonalModalOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isPersonalModalOpen, closePersonalModal]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                closeLoginModal(); // Close modal when clicking outside
            }
        };

        if (isLoginModalOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isLoginModalOpen, closeLoginModal]);


    return (
        <>
            <div className="profileBooking p-3">
                <h5 className="text-white text-start container">Complete Your Booking</h5>
            </div>
            <div className="profileMainContainer py-5 profileHeightDiv">
                {user && (
                    <div className="container row m-auto personalInfoDiv">
                        <div className="personalInfoLeft">
                            <div className="personalUserimg">
                                <img src="./assets/images/userIconProfile.png" alt="" />
                                <h3>{user.employeeName}</h3>
                            </div>
                            <div className="profileOptions">
                                <div
                                    className={`profileEdit my-2 ${activeTab === 'editProfile' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('editProfile')}>
                                    <img src="./assets/images/userIcon.png" alt="Edit Profile" />
                                    <a href="/profile">Edit Profile</a>
                                </div>
                                <div
                                    className={`profileEdit my-2 ${activeTab === 'changePassword' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('changePassword')}>
                                    <img src="/assets/images/changePassword.png" alt="Change Password" />
                                    <a href="#loginDetails" className='text-start'>Change Password</a>
                                </div>
                            </div>
                        </div>
                        <div className="ProfileRightContainer">
                            <div className="personalInfoRight">
                                <div className="personalInfoContainer">
                                    <div className="infoCard">
                                        <div className="cardHeader">
                                            <h2>Personal Information</h2>
                                            <button className="editButton" onClick={openPersonalModal}>
                                                Edit{' '}
                                                <span role="img" aria-label="edit">
                                                    <img src="/assets/images/editIcon1.png" alt="" className="mx-1" />
                                                </span>
                                            </button>
                                        </div>
                                        <div className="cardContent mt-4">
                                            <div>
                                                <p className="text-muted w-50 text-start">Full Name:</p>
                                                <p className="text-start w-50">{user.employeeName}</p>
                                            </div>
                                            <div>
                                                <p className='text-muted w-50 text-start'>Frequent Flyer Number:</p>
                                                <p className='text-start w-50'>{user.frequentFlyerNo}</p>
                                            </div>
                                            <div>
                                                <p className="text-muted w-50 text-start">Mobile Number:</p>
                                                <p className="text-start w-50">
                                                    +{user.countryCode} {user.mobileNo}
                                                </p>
                                            </div>
                                            <div>
                                                <p className="text-muted w-50 text-start">Email ID:</p>
                                                <p className="text-start w-50">{user.employeeEmail}</p>
                                            </div>
                                            <div>
                                                <p className="text-muted w-50 text-start">Date of Birth:</p>
                                                <p className="text-start w-50">{new Date(user.dob).toLocaleDateString('en-US', {
                                                    weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
                                                })}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="personalInfoRight mt-4" id="loginDetails">
                                <div className="personalInfoContainer">
                                    <div className="infoCard">
                                        <div className="cardHeader">
                                            <h2>Login Details</h2>
                                            <button className="editButton" onClick={openLoginModal}>
                                                Edit
                                                <span role="img" aria-label="edit">
                                                    <img src="/assets/images/editIcon1.png" alt="" className="mx-1" />
                                                </span>
                                            </button>
                                        </div>
                                        <div className="cardContent mt-4">
                                            <div>
                                                <p className="text-muted w-50 text-start">Phone Number:</p>
                                                <p className="text-start w-50">{user.mobileNo}</p>
                                            </div>
                                            <div>
                                                <p className="text-muted w-50 text-start">Email ID:</p>
                                                <p className="text-start w-50">{user.employeeEmail}</p>
                                            </div>
                                            <div>
                                                <p className="text-muted w-50 text-start">Password:</p>
                                                <p className="text-start w-50">********</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {/* Personal Info Modal */}
                {isPersonalModalOpen && (
                    <div className="modal">
                        <div className="modal-content profile-edit-div" ref={modalRef}>
                            <h4 className='text-start mb-4 mt-2'>Edit Personal Information</h4>
                            <form className="personal-info-form">
                                <div className="form-group profileFormDiv">
                                    <input type="text" placeholder="Full Name" className="input-field"
                                        value={user.employeeName} onChange={(e) => setFullNamea(e.target.value)}></input>
                                    <input type="text" placeholder='Frequent Flyer Number' className='input-field'
                                        value={user.frequentFlyerNumber} onChange={(e) => setFrequentFlyerNumbera(e.target.value)}></input>
                                </div>
                                <div className="form-group profileFormDiv">
                                    <select className="form-control" onChange={handleCountryChange} value={user.countryCode || ""}>
                                        <option value="">Select Country</option>
                                        {countryCode.map((country) => (
                                            <option key={country.id} value={country.mobileCode}>
                                                {country.name} (+{country.mobileCode})
                                            </option>
                                        ))}
                                    </select>
                                    <input type="number" placeholder="Mobile Number" className="input-field" value={user.mobileNo}
                                        onChange={(e) => setUser({ ...user, mobileNo: e.target.value })}  />
                                </div>
                                <div className="form-group profileFormDiv">
                                    <input type="email" placeholder="Email" disabled className="input-field" value={user.employeeEmail} />
                                    <input type="date" placeholder="DOB" className="input-field"
                                        value={user.dob ? new Date(user.dob).toLocaleDateString('en-CA') : ''}
                                        onChange={(e) => setDoba(e.target.value)}
                                        min={new Date(new Date().getFullYear() - 99, new Date().getMonth(), new Date().getDate()).toISOString().split('T')[0]}
                                        max={new Date(new Date().getFullYear() - 12, new Date().getMonth(), new Date().getDate()).toISOString().split('T')[0]}
                                    />
                                </div>
                                <div className='profileButtons my-4'>
                                    <button type="button" className="profile-cancel-btn" onClick={closePersonalModal}>
                                        Cancel
                                    </button>
                                    <button type='button' className="profile-submit-btn" onClick={setUserDetail}>
                                        Save Changes
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                )}

                {/* Login Info Modal */}
                {isLoginModalOpen && (
                    <div className="modal">
                        <div className="modal-content-login" ref={modalRef}>
                            <h4 className='text-start mb-4 mt-2'>Change Password</h4>
                            <form>
                                <div className='login-password-details'>
                                    <div className="password-container">
                                        <input
                                            className="loginInput"
                                            type={showOldpassword ? "text" : "password"}
                                            placeholder="Old Password"
                                            value={oldPassword}
                                            onChange={(e) => setOldPassword(e.target.value)}
                                            required
                                        />
                                        <span
                                            className="password-toggle-icon-profile"
                                            onClick={() => setShowOldpassword(!showOldpassword)}
                                        >
                                            {showOldpassword ? <FaEye /> : <FaEyeSlash />}
                                        </span>
                                    </div>
                                    <div className="password-container">
                                        <input
                                            className="loginInput"
                                            type={showNewpassword ? "text" : "password"}
                                            placeholder="New Password"
                                            value={Newpassword}
                                            onChange={(e) => setNewpassword(e.target.value)}
                                            required
                                        />
                                        <span
                                            className="password-toggle-icon-profile"
                                            onClick={() => setShowNewpassword(!showNewpassword)}
                                        >
                                            {showNewpassword ? <FaEye /> : <FaEyeSlash />}
                                        </span>
                                    </div>
                                    <div className="password-container">
                                        <input
                                            className="loginInput"
                                            type={showNewconfirm ? "text" : "password"}
                                            placeholder="Confirm New Password"
                                            value={Newconfirm}
                                            onChange={(e) => SetNewconfirm(e.target.value)}
                                            required
                                        />
                                        <span
                                            className="password-toggle-icon-profile"
                                            onClick={() => setShowNewconfirm(!showNewconfirm)}
                                        >
                                            {showNewconfirm ? <FaEye /> : <FaEyeSlash />}
                                        </span>
                                    </div>
                                </div>
                                <div className='profileButtons my-4'>
                                    <button type="button" className="profile-cancel-btn" onClick={closeLoginModal}>
                                        Cancel
                                    </button>
                                    <button type='button' className="profile-submit-btn" onClick={setPassword}>
                                        Submit
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Profile;